import styled from 'styled-components';

// The cart's one-reader chip, at the right end of the Cart header row (owner
// 23 Oct). min-width 0 lets a long reader name shorten instead of pushing the
// row wider than the cart.
export const Chip = styled.div`
  display: flex;
  min-width: 0;
  justify-content: flex-end;
`;

// Owner 24 Oct ("keep it live"): the live channel is down; the dots still
// come from the 5 s read. A small grey note, never a layout change of the row.
export const Reconnecting = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  align-self: center;
  color: ${({ theme }) => theme.colors.grey.primary.standard};

  ${Chip} > & {
    margin-right: 8px;
  }
`;

// Rule 1 (24 Oct, measured on Dev): the note sits on the "Select Device"
// label row, right-aligned with the picker (same centre line as the label, same
// right edge as the control), so the cart below never moves.
export const PickerWrap = styled.div`
  position: relative;

  > ${Reconnecting} {
    position: absolute;
    top: 4px;
    right: ${({ theme }) => (theme.responsive.isDesktop ? '16px' : '0')};
  }
`;
